import { QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMembers, updateMemberRoleQuery } from '../services/taskService';
import { BoardMember } from '../types/task';
import { MemberRole } from '../contract';
import { withMemberAccess } from './memberTransforms';
import { queryKeys } from './queryKeys';

// Who is on a board, and changing what they may do. Like the other slices, a screen calls a hook here and never
// edits the cache itself.

export const membersOptions = (boardId: string) => ({
    queryKey: queryKeys.members(boardId),
    queryFn: () => getMembers(boardId),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
});

export const useMembers = (boardId: string) => useQuery(membersOptions(boardId));

export type MemberAccess = { member: BoardMember, role: MemberRole, kiosk: boolean };

export const updateMemberAccessMutation = (queryClient: QueryClient, boardId: string) => ({
    mutationFn: ({ member, role, kiosk }: MemberAccess) => updateMemberRoleQuery(boardId, member.userId, role, kiosk),
    onSuccess: (_result: unknown, { member, role, kiosk }: MemberAccess) => {
        queryClient.setQueryData<BoardMember[]>(queryKeys.members(boardId), (members) => withMemberAccess(members, member.id, role, kiosk));
    },
});

export const useUpdateMemberAccess = (boardId: string) => useMutation(updateMemberAccessMutation(useQueryClient(), boardId));
